import { retrieveTokens } from "$api/tokenManagement";

const tokenInterceptor = (config) => {
  const { bearerToken } = retrieveTokens();
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${bearerToken}`,
    },
  };
};

export default tokenInterceptor;
